import React from 'react';
import NavBarLayout from './NavBarLayout';
import JobsForm from '../components/JobsForm';

const routes = [
  {
    title: 'Nosotros',
    slug: 'nosotros',
    path: '/nosotros',
  },
  {
    title: 'Nuestra cultura',
    slug: 'nuestra-cultura',
    path: '/nosotros/nuestra-cultura',

  },
  {
    title: 'Conciencia Cinemex',
    slug: 'conciencia-cinemex',
    path: '/nosotros/conciencia',
  },
  {
    title: 'Nuestro compromiso',
    slug: 'nuestro-compromiso',
    path: '/nosotros/nuestro-compromiso',
  },
  {
    title: 'Bolsa de trabajo de cines',
    component: JobsForm,
    path: '/empleos/formulario',
  }
];

export default props => <NavBarLayout fixedTitle="Sobre Cinemex" routes={routes}/>